/**
 * @generated SignedSource<<5c0c1f8a61a62522d5c829ded81dd4c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssetType = "CLIENT_FORM_IMAGE" | "COMPONENT_TEMPLATE" | "FEEDBACK_FILE" | "FEEDBACK_IMAGE" | "GROUP_IMAGE" | "LIBRARY_AUDIO" | "LIBRARY_FILE" | "LIBRARY_IMAGE" | "LIBRARY_VIDEO" | "MEAL_PHOTO" | "MESSAGE_FILE" | "MESSAGE_IMAGE" | "PORTAL_LOGO" | "PROGRAM_AUDIO" | "PROGRAM_CHECKIN_FILE" | "PROGRAM_CHECKIN_PHOTO" | "PROGRAM_COVER" | "PROGRAM_FILE" | "PROGRAM_IMAGE" | "PROGRAM_VIDEO" | "USER_PHOTO" | "WORKOUT_MEDIA" | "%future added value";
export type MediaElementPopoverCreateUploadUrlMutation$variables = {
  file: string;
  id: string;
  type: AssetType;
};
export type MediaElementPopoverCreateUploadUrlMutation$data = {
  readonly createSignedUrl: {
    readonly url: string | null | undefined;
  } | null | undefined;
};
export type MediaElementPopoverCreateUploadUrlMutation = {
  response: MediaElementPopoverCreateUploadUrlMutation$data;
  variables: MediaElementPopoverCreateUploadUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "file"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "file",
        "variableName": "file"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "CreateSignedUrlPayload",
    "kind": "LinkedField",
    "name": "createSignedUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MediaElementPopoverCreateUploadUrlMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "MediaElementPopoverCreateUploadUrlMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2f189a6b16a93ef234488312d78d3765",
    "id": null,
    "metadata": {},
    "name": "MediaElementPopoverCreateUploadUrlMutation",
    "operationKind": "mutation",
    "text": "mutation MediaElementPopoverCreateUploadUrlMutation(\n  $id: ID!\n  $file: String!\n  $type: AssetType!\n) {\n  createSignedUrl(id: $id, file: $file, type: $type) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "051b13c31ca017644d41964f9cc5f990";

export default node;
